export var EProductTypeNames;
(function (EProductTypeNames) {
    EProductTypeNames["Wealth_Product"] = "Wealth Product";
    EProductTypeNames["EquityAndMore"] = "Equity and more";
})(EProductTypeNames || (EProductTypeNames = {}));
export var EProductTypeIds;
(function (EProductTypeIds) {
    EProductTypeIds["Wealth_Product"] = "1";
    EProductTypeIds["EquityAndMore"] = "2";
})(EProductTypeIds || (EProductTypeIds = {}));
export var EProductIds;
(function (EProductIds) {
    EProductIds["FIXED_INCOME"] = "54";
    EProductIds["MANAGED_PORTFOLIO"] = "56";
    EProductIds["LIFE_INSURANCE"] = "9";
    EProductIds["GENERAL_INSURANCE"] = "10";
    EProductIds["LIABILITIES"] = "59";
    EProductIds["REAL_ESTATE"] = "75";
    EProductIds["SUBSCRIPTION"] = "76";
    EProductIds["EQUITY"] = "61";
    EProductIds["COMMODITY"] = "71";
    EProductIds["DERIVATIVE"] = "62";
})(EProductIds || (EProductIds = {}));
export var ESubProductIds;
(function (ESubProductIds) {
    ESubProductIds["ListedShares"] = "277";
    ESubProductIds["UnlistedShares"] = "278";
    ESubProductIds["SLBM"] = "337";
    ESubProductIds["IDR"] = "338";
    ESubProductIds["PreferenceShares"] = "341";
    ESubProductIds["SMTF"] = "342";
    ESubProductIds["IPO"] = "343";
    ESubProductIds["OFS"] = "344";
    ESubProductIds["Rights"] = "345";
    ESubProductIds["Buyback"] = "346";
    ESubProductIds["Smallcase"] = "350";
    ESubProductIds["SGB"] = "347";
    ESubProductIds["Equity"] = "331";
    ESubProductIds["Currency"] = "332";
    ESubProductIds["Commodity"] = "333";
    ESubProductIds["Bonds"] = "256";
    ESubProductIds["NCD"] = "257";
    ESubProductIds["CorporateFD"] = "302";
    ESubProductIds["MutualFund"] = "261";
    ESubProductIds["Infinity"] = "282";
    ESubProductIds["REITs"] = "294";
    ESubProductIds["LAS"] = "272";
    ESubProductIds["ESOP"] = "273";
    ESubProductIds["HousingLoan"] = "274";
    ESubProductIds["Mortgage"] = "275";
    ESubProductIds["IPOFunding"] = "276";
    ESubProductIds["Unsecured"] = "321";
    ESubProductIds["LAP"] = "334";
    ESubProductIds["MotorInsurance"] = "46";
    ESubProductIds["HealthInsurance"] = "47";
    ESubProductIds["FireInsurance"] = "50";
    ESubProductIds["BurglaryInsurance"] = "352";
    ESubProductIds["MarineInsurance"] = "353";
    ESubProductIds["PAGroupInsurance"] = "354";
    ESubProductIds["HealthGroupInsurance"] = "355";
    ESubProductIds["MarineCargoInsurance"] = "356";
    ESubProductIds["TermInsurance"] = "40";
    ESubProductIds["SavingInvestmentInsurance"] = "351";
    ESubProductIds["PMS"] = "268";
    ESubProductIds["ETF"] = "279";
    ESubProductIds["StructuredProducts"] = "292";
    ESubProductIds["AIF"] = "293";
    ESubProductIds["INVITs"] = "335";
    ESubProductIds["NFO"] = "336";
    ESubProductIds["CapitalGainsBond54EC"] = "300";
    ESubProductIds["RBIBonds"] = "301";
    ESubProductIds["CommercialPaper"] = "339";
    ESubProductIds["Warrant"] = "340";
})(ESubProductIds || (ESubProductIds = {}));
export var EProductNames;
(function (EProductNames) {
    EProductNames["FIXED_INCOME"] = "Fixed Income";
    EProductNames["MANAGED_PORTFOLIO"] = "Managed Portfolio";
    EProductNames["LIFE_INSURANCE"] = "Life Insurance";
    EProductNames["GENERAL_INSURANCE"] = "General Insurance";
    EProductNames["LIABILITIES"] = "Liabilities";
    EProductNames["REAL_ESTATE"] = "Real Estate";
    EProductNames["SUBSCRIPTION"] = "Subscription";
    EProductNames["EQUITY"] = "Equity";
    EProductNames["COMMODITY"] = "Commodity";
    EProductNames["DERIVATIVE"] = "Derivative";
})(EProductNames || (EProductNames = {}));
export var ESubProductNames;
(function (ESubProductNames) {
    ESubProductNames["MutualFund"] = "Mutual Funds";
    ESubProductNames["PMS"] = "PMS";
    ESubProductNames["ETF"] = "ETF";
    ESubProductNames["StructuredProducts"] = "Structured Products";
    ESubProductNames["AIF"] = "AIF";
    ESubProductNames["INVITs"] = "INVITs";
    ESubProductNames["NFO"] = "NFO";
    ESubProductNames["Infinity"] = "Infinity";
    ESubProductNames["Bonds"] = "Bonds";
    ESubProductNames["NCD"] = "NCD";
    ESubProductNames["CapitalGainsBond54EC"] = "Capital Gains Bond (54 EC)";
    ESubProductNames["RBIBonds"] = "RBI Bonds";
    ESubProductNames["CorporateFD"] = "Corporate FD";
    ESubProductNames["CommercialPaper"] = "Commercial Paper";
    ESubProductNames["Warrant"] = "Warrant";
    ESubProductNames["REITs"] = "REITs";
    ESubProductNames["LAP"] = "LAP";
    ESubProductNames["ESOP"] = "ESOP";
    ESubProductNames["HousingLoan"] = "Housing Loan";
    ESubProductNames["Mortgage"] = "Mortgage";
    ESubProductNames["IPOFunding"] = "IPO Funding";
    ESubProductNames["Unsecured"] = "Unsecured";
    ESubProductNames["LAS"] = "LAS";
    ESubProductNames["MotorInsurance"] = "Motor Insurance";
    ESubProductNames["HealthInsurance"] = "Health Insurance";
    ESubProductNames["FireInsurance"] = "Fire Insurance";
    ESubProductNames["BurglaryInsurance"] = "Burglary Insurance";
    ESubProductNames["MarineInsurance"] = "Marine Insurance";
    ESubProductNames["PAGroupInsurance"] = "PA Group Insurance";
    ESubProductNames["HealthGroupInsurance"] = "Health Group Insurance";
    ESubProductNames["MarineCargoInsurance"] = "Marine Cargo Insurance";
    ESubProductNames["TermInsurance"] = "Term Insurance";
    ESubProductNames["SavingInvestmentInsurance"] = "Saving & Investment Insurance";
    ESubProductNames["ListedShares"] = "Listed Shares";
    ESubProductNames["UnlistedShares"] = "Unlisted Shares";
    ESubProductNames["SLBM"] = "SLBM";
    ESubProductNames["IDR"] = "IDR";
    ESubProductNames["PreferenceShares"] = "Preference Shares";
    ESubProductNames["SMTF"] = "SMTF";
    ESubProductNames["IPO"] = "IPO";
    ESubProductNames["OFS"] = "OFS";
    ESubProductNames["Rights"] = "Rights";
    ESubProductNames["Buyback"] = "Buyback";
    ESubProductNames["SmallCase"] = "Smallcase";
    ESubProductNames["SGB"] = "SGB";
    ESubProductNames["Equity"] = "Equity";
    ESubProductNames["Currency"] = "Currency";
    ESubProductNames["Commodity"] = "Commodity";
})(ESubProductNames || (ESubProductNames = {}));
